<nav class="bg-white border-b-offwhite border-b-2 px-4 py-5 overflow-x-auto">
  <div class="container mx-auto">
    <ul class="list-none flex items-center text-base text-black">
      <li
        *ngFor="let item of routes"
        class="mr-5 cursor-pointer text-sm flex items-center"
        [routerLink]="item.route"
        [routerLinkActiveOptions]="{
          exact: item.routeExact || true
        }"
        routerLinkActive="router-active"
      >
        <ion-icon [name]="item.icon" class="mr-2"></ion-icon>
        {{ item.title }}
      </li>
    </ul>
  </div>
</nav>
